import gn from "refractor/gn";
export default gn;